<template>
  <div class="download">
    <div v-if="data.type=='album'" id="album">
      <div @click="menuSelect(index)" v-for="item,index in data.data[data.type]" :key="index">
        <h1>
          <h2></h2>
          <img :src="require('@/assets/pic/download/dnarr.png')" />
        </h1>
        <img :src="item.pic" />
        <label>{{item.label}}</label>
      </div>
    </div>

    <div v-if="data.type=='docs'" id="docs">
      <div id="dmenu">
        <div @mouseover="menuSelect(index)" :class="setMenuClass(index)" v-for="item,index in data.category" :key="index">{{item.label}}</div>
      </div>
      <div id="dct">
        <div>暂无资料</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    return {
      mnindex: 0,
    }
  },
  methods: {
    setMenuClass (index) {
      return this.mnindex==index?'mnnor mnsel':'mnnor'
    },
    menuSelect (index) {
      this.mnindex = index
      if (this.data.type=='album') {
        var url = ''
        switch (index) {
          case 0:
            url = 'http://dl.szzt.com.cn/download/solutions/finance-solutions.pdf'
            break;
          case 1:
            url = 'http://dl.szzt.com.cn/download/solutions/face-solutions.pdf'
            break;
          case 2:
            url = 'http://dl.szzt.com.cn/download/solutions/industry-solutions.pdf'
            break;
          case 3:
            url = 'http://dl.szzt.com.cn/download/solutions/mobile-solutions.pdf'
            break;
          case 4:
            url = 'http://dl.szzt.com.cn/download/solutions/SID-solutions.pdf'
            break;
          default:
            break;
        }
        window.open(url,'_blank')
      }
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download {
  background: #F7F8F8;
}
#album {
  min-height: 5.41rem;
  text-align: left;
  padding-top: .5rem;
  width: 12.72rem;
  margin: 0 auto;
}
#album div {
  overflow: hidden;
  width: 2.93rem;
  height: 3.26rem;
  display: inline-block;
  margin: 0 .1rem 0 .1rem;
  cursor: pointer;
  margin-bottom: .2rem;
  text-align: center;
}
#album h1 {
  position: absolute;
  height: 2.62rem;
  width: 2.93rem;
  margin: 0;
  opacity: 0;
}
#album h2 {
  margin: 0;
  position: absolute;
  height: 2.62rem;
  width: 2.93rem;
  background: black;
  opacity: 0.2924;
  z-index: 5;
}
#album h1 img {
  width: .57rem !important;
  height: .57rem !important;
  display: inline-block !important;
  margin: 1.03rem 0 0 -.285rem !important;
  position: absolute !important;
  z-index: 5;
}
#album img {
  /* height: 2.62rem; */
  height: 3.26rem;
  width: 2.93rem;
  display: block;
  position: absolute;
}
#album label {
  margin: 2.62rem 0;
  padding: 0;
  display: block;
  position: absolute;
  width: 2.93rem;
  height: .64rem;
  line-height: .64rem;
  background: white;
  font-size: .2rem;
  font-weight: 400;
  color: #555555;
}
#album div:hover label {
  background: #EF8200;
  opacity: 0.86;
  color: white;
}
#album div:hover h1 {
  opacity: 1;
}

#docs {
  height: 5.41rem;
  text-align: center;
}
#dmenu {
  display: inline-block;
  background: white;
  width: 2.24rem;
  height: 3.12rem;
  margin-right: .2rem;
  vertical-align: top;
  padding-top: .12rem;
}

.mnnor {
  height: .63rem;
  line-height: .63rem;
  cursor: pointer;
  font-size: .18rem;
  font-weight: 400;
  color: #4E4E4E;
}
.mnsel {
  color: white;
  background: #EF8200;
}
#dct {
  display: inline-block;
  background: white;
  width: 9.81rem;
  height: 5.41rem;
  margin: auto;
  overflow: hidden;
}
#dct div {
  margin-top: .4rem;
}


</style>
